import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AppointeePage } from '@/pages/admin/appointee';
import { appointeeSearchSchema } from '@/routes/-shared/appointeeSearchSchema';

/**
 * La pagina dell'incaricato resta montata e sopra di lei, sull'`Outlet`, si
 * aprono il dialogo delle credenziali (`credentials`) e il dettaglio di un
 * tenant delegato (`$id`): chiuderli torna alla pagina. Tab e ricerca della
 * lista dei tenant delegati e la scheda del dettaglio stanno nell'URL.
 */
export const Route = createFileRoute('/admin/_layout/appointee/_layout')({
  component: AppointeeLayout,
  validateSearch: appointeeSearchSchema,
});

function AppointeeLayout() {
  return (
    <>
      <AppointeePage />
      <Outlet />
    </>
  );
}
